import { Stack, Typography } from "@mui/material";
import MainNavBar from "../components/MainNavBar";
import SettingsSection from "../components/Settings/SettingsSection";

function Settings() {
  return (
    <Stack sx={{ bgcolor: "#f5f6f7" }}>
      <MainNavBar />
      <SettingsSection />
    </Stack>
  );
}

export default Settings;
